<template>
  <div id="404" class="k404">
    <div class="k404C">
      <img src="../../public/images/2.png" alt />
      <div>
        <p>对不起！您访问的页面不存在或已删除!</p>
        <p>
          <span id="tTime">
            {{time}}
            <em>秒后</em>
            <el-link :underline="false" type="primary" @click="returnIndex">返回首页</el-link>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      interval: '',
      time: '5'
    }
  },
  methods: {
    returnIndex: function() {
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.$router.push('/')
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  mounted: function() {
    this.interval = setInterval(() => {
      this.time--
      //等于0时跳转首页
      if (this.time == 0) {
        clearInterval(this.interval)
        this.$router.push('/')
      }
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
.k404 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  .k404C {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    div {
      margin-top: 20px;
      line-height: 30px;
      p {
        font-weight: bold;
        font-size: 14px;
        margin-right: 20px;
        span {
          color: red;
        }
      }
    }
  }
}
#tTime{
	display: flex;
	em{
		color:#409EFF;
	}
	a{
		margin-left: 10px;
	}
}
</style>